
import classNames from 'classnames';
import { Container } from 'reactstrap';
import NavBar2 from './Navbar2';
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import {Login} from "../../Login"
import { getAuth, onAuthStateChanged } from "firebase/auth";

import Ask  from "./Ask"

// import { Link, useNavigate } from "react-router-dom";
// import { auth, logInWithEmailAndPassword,logout, signInWithGoogle } from "./firebase";

// var __html = require('../../privacy.html');
// var template = { __html: __html };


class ContactCom extends React.Component {

  

  constructor(props) {
    super(props);

    this.state = {
    }

    this.previousWidth = -1;

    
  }



  render() {
    return (

      

      <Container  fluid className={classNames('ContactCom', { 'is-open': this.props.isOpen })}>


      <Ask></Ask>
        
      </Container>

      
    );
  }
}




export default ContactCom;
